import React, { useEffect, useState, useRef } from 'react';
import { CheckIcon, FilterIcon } from 'lucide-react';
interface StatusFilterDropdownProps {
  selectedStatus: string;
  onChange: (status: string) => void;
  darkMode?: boolean;
}
export const StatusFilterDropdown: React.FC<StatusFilterDropdownProps> = ({
  selectedStatus,
  onChange,
  darkMode = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);
  // Updated statuses to match actual lesson status values
  const statuses = [{
    value: 'all',
    label: 'All Statuses'
  }, {
    value: 'upcoming',
    label: 'Upcoming'
  }, {
    value: 'completed',
    label: 'Completed'
  }, {
    value: 'canceled',
    label: 'Canceled'
  }, {
    value: 'confirmed',
    label: 'Confirmed'
  }
  // Removed status values that don't match actual lesson statuses:
  // 'active', 'pending', 'trial', 'inactive'
  ];
  const getStatusLabel = () => {
    const status = statuses.find(s => s.value === selectedStatus);
    return status ? status.label : 'All Statuses';
  };
  return <div className="relative" ref={dropdownRef} data-id="element-11431">
      {/* Dropdown Button */}
      <button onClick={() => setIsOpen(!isOpen)} className={`flex items-center justify-between w-full px-4 py-2.5 text-sm rounded-lg ${darkMode ? 'bg-navy-900/50 text-white border-navy-700 hover:bg-navy-800' : 'bg-gray-50 text-gray-800 border-gray-300 hover:bg-gray-100'} border transition-colors duration-200`} data-id="element-11432">
        <span className="truncate pr-6 flex items-center" data-id="element-11433">
          <FilterIcon className="h-4 w-4 mr-2" data-id="element-11434" />
          {getStatusLabel()}
        </span>
        <svg className={`h-5 w-5 transform transition-transform ${isOpen ? 'rotate-180' : ''} ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-11435">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-11436" />
        </svg>
      </button>
      {/* Dropdown Menu */}
      {isOpen && <div className={`absolute z-50 mt-2 w-full rounded-lg shadow-lg ${darkMode ? 'bg-navy-800 text-white border border-navy-700' : 'bg-white text-gray-800 border border-gray-200'}`} data-id="element-11437">
          {statuses.map(status => <button key={status.value} onClick={() => {
        onChange(status.value);
        setIsOpen(false);
      }} className={`w-full text-left px-4 py-2.5 text-sm flex items-center ${selectedStatus === status.value ? darkMode ? 'bg-navy-700' : 'bg-red-50' : darkMode ? 'hover:bg-navy-700' : 'hover:bg-gray-50'}`} data-id="element-11438">
              {selectedStatus === status.value ? <CheckIcon className="h-4 w-4 text-deep-pink mr-2" data-id="element-11439" /> : <div className="w-4 mr-2" data-id="element-11440"></div>}
              <span data-id="element-11441">{status.label}</span>
            </button>)}
        </div>}
    </div>;
};